import { BracketTournamentRounds } from 'src/app/gamification/command-center/models/games.model';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { DatePipe } from '@angular/common';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import moment from 'moment';

@Component({
  selector: 'cv-configure-schedule-brackets',
  templateUrl: './configure-schedule-brackets.component.html',
  styleUrl: './configure-schedule-brackets.component.scss'
})
export class ConfigureScheduleBracketsComponent implements OnInit {
    @Input() step: number;
    @Input() numberOfRounds: number;
    @Input() componentOptions: any;
    @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

    gs = null;
    
    rounds: BracketTournamentRounds[];
    availableRounds: BracketTournamentRounds[] = [];

    today: moment.Moment = moment();
    earliestDate: moment.Moment = moment().startOf('date');
    isTournamentActive: boolean;
    isCxone = false;

    constructor(
        private gamesService: GamesService,
        private cvConfigurationService: CvConfigurationService,
      ) {
        this.gs = this.gamesService.data;
    }

    async ngOnInit() {
        this.gs.modified.item.Schedule = this.gs.modified.item.Schedule || {
            IntervalType: 0,
            Ongoing: true,
            StartDate: new Date(),
            EndDate: null
        };

        // Initialize rounds
        for (let i = 4; i > 0; i--) {
            this.availableRounds.push({
                RoundID: 0,
                RoundNumber: i,
                RoundName: this.getRoundName(i),
                StartDate: null,
                EndDate: new Date()
            });
        }

        this.gs.modified.item.BracketTournamentRounds =  this.gs.modified.item.BracketTournamentRounds || this.availableRounds.slice(-this.numberOfRounds);
        this.rounds = this.gs.modified.item.BracketTournamentRounds;

        this.rounds.forEach(round => {
            if (!round.RoundName) {
                round.RoundName = this.getRoundName(round.RoundNumber);
                round.StartDate = new Date(round.StartDate);
                round.EndDate = new Date(round.EndDate);
            }
        });

        this.isTournamentActive = moment(this.rounds[this.rounds.length-1].EndDate).isAfter(this.today);
        this.isCxone = this.cvConfigurationService.isCxOne;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.numberOfRounds && this.rounds) {
            this.numberOfRounds = parseInt(changes.numberOfRounds.currentValue);
            this.rounds = this.availableRounds.slice(-this.numberOfRounds);
            this.gs.modified.item.BracketTournamentRounds = this.rounds;
        }
    }

    // Localization functions
    datePlaceHolder(): string {
        return this.gamesService.getLocalizedMessage('Select_Date', 'Select Date');
    }

    getRoundName(roundNumber: number) {
        switch(roundNumber) {
            case 1:
                return 'Round_1_Final';
            case 2:
                return 'Round_2_Semi_Finals';
            case 3:
                return 'Round_3_Quarter';
            case 4:
                return 'Round_4_Octaves';
        }
    }

    handleDateChanged(i: number) {     
        if (this.rounds[i].StartDate) {
            this.rounds[i].EndDate = moment(this.rounds[i].StartDate).endOf('day').toDate();
            if (this.rounds[i].RoundName === "Round_1_Final") {
                this.gs.modified.item.Schedule.EndDate = this.rounds[i].EndDate;
            }
        }
    };

    // Validations
    isDateInvalid(i: number) {
        if (!this.isTournamentActive && moment(this.rounds[i].EndDate).isBefore(this.today)) {
            return true
        };

        if (moment(this.rounds[i].EndDate).isBefore(this.today) && this.gs.modified.item.underlyingRule.IsCopy) {
            return true
        };

        if (i === 0) return false;

        const current = this.rounds[i].StartDate ? new Date(this.rounds[i].StartDate) : null;
        if (!current) return false;

        for(let x = i; x > 0; x--) {
            const previous = this.rounds[x-1].StartDate ? new Date(this.rounds[x-1].StartDate) : null;
            if (!previous) continue;
            if (current <= previous){
                return true
            };
        }

        return false;
    }

    isDateInPast(date: Date) {
        if (date == null || !this.rounds || !this.isTournamentActive) return false;
        if (this.gs.modified.item.underlyingRule.IsCopy) return false;
        return moment(date).isBefore(this.today);
    }
}
